import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m13.73 2.994 9.266 16.004c.772 1.333-.19 3.002-1.73 3.002H2.734c-1.54 0-2.502-1.669-1.73-3.002l9.265-16.004c.77-1.33 2.692-1.33 3.462 0zM12 3.996 2.734 20h18.532zM12 16a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }